import type { PnlReportSummary } from 'src/components/star-grid/starGridTypes';

/** One report added (at the front, as the list route orders) or renamed in place; a new one shows as `GENERATING`. */
export const upsertPnlReport = (list: PnlReportSummary[] | undefined, id: number, name: string): PnlReportSummary[] => {
  const current = list ?? [];
  const existing = current.find((report) => report.pnl_report_id === id);
  if (existing) {
    const merged = { ...existing, ...(name ? { report_name: name } : {}) };
    return current.map((report) => (report.pnl_report_id === id ? merged : report));
  }
  return [{ pnl_report_id: id, report_name: name, status: 'GENERATING' }, ...current];
};
